
let DataPage = {
    "dataConfig" : [],
    "accessDash" : [],
    "home"       : [],
    "works"      : [],
    "about"      : [],
    "contact"    : [],
    "portfolio"  : []
};

let NotifyDataPage = {
    "dataConfig" : [],
    "accessDash" : [],
    "home"       : [],
    "works"      : [],
    "about"      : [],
    "contact"    : [],
    "portfolio"  : []
}

export function SetListData(value) {
    DataPage = value;
    NotifyDataPage["dataConfig"].forEach(element => {
        element(value['dataConfig']);
    });
    NotifyDataPage["accessDash"].forEach(element => {
        element(value['accessDash']);
    });
    NotifyDataPage["home"].forEach(element => {
        element(value['home']);
    });
    NotifyDataPage["works"].forEach(element => {
        element(value['works']);
    });
    NotifyDataPage["about"].forEach(element => {
        element(value['about']);
    });
    NotifyDataPage["contact"].forEach(element => {
        element(value['contact']);
    });
    NotifyDataPage["portfolio"].forEach(element => {
        element(value['portfolio']);
    });
}

export function SetListDataSingle(key, value) {
    DataPage[key] = value;
    NotifyDataPage[key].forEach(element => {
        element(value);
    });
}

export function GetDataPage(key){
    return DataPage[key];
}

export function RegisterDataPage(key, value){
    if(!NotifyDataPage[key]){
        NotifyDataPage[key] = [];
    }
    NotifyDataPage[key].push(value);
}
